let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fiQhv")).then(() => parcelRequire('iJga8'));